import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { CallerSubscriptionInput } from '@/models/callerPlan';

export const updateCallerSubscription = async ({
  callerId,
  planName,
  nextPlanName,
  timePlanSuspendPeriodStartDate,
  timePlanSuspendPeriodEndDate,
  expectedPeriodEndAt,
}: CallerSubscriptionInput) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      planName,
      nextPlanName,
      timePlanSuspendPeriodStartDate,
      timePlanSuspendPeriodEndDate,
      expectedPeriodEndAt,
    },
    mutation: graphql(`
      mutation UpdateCallerSubscription(
        $callerId: String!
        $planName: String
        $nextPlanName: String
        $timePlanSuspendPeriodStartDate: String
        $timePlanSuspendPeriodEndDate: String
        $expectedPeriodEndAt: String
      ) {
        updateCallerSubscription(
          callerId: $callerId
          planName: $planName
          nextPlanName: $nextPlanName
          timePlanSuspendPeriodStartDate: $timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate: $timePlanSuspendPeriodEndDate
          expectedPeriodEndAt: $expectedPeriodEndAt
        ) {
          id
          callerId
          planName
          nextPlanName
          periodStartAt
          periodEndAt
          expectedPeriodEndAt
          isTrial
          transactionId
          timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate
        }
      }
    `),
  });

  return response.data?.updateCallerSubscription;
};
